module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noOrdersFound":"No orders found","orderNumber":"Order","etd":"Etd/Atd","from":"From","to":"To"},"no":{"noOrdersFound":"Fant ingen oppdrag","orderNumber":"Oppdrag","etd":"Eta/Ata","from":"Fra","to":"Til"}}')
  delete Component.options._Ctor
}
